
import { useEffect, useState } from "react"
import styled from "styled-components"
import { getCityIklimIndex, getTopluNakliyeCityIklimIndexExcel, updateCityIklimIndex} from "../../features/nakliyeIndex/nakliyeIndexSlice"
import { useDispatch, useSelector } from "react-redux"
import Btn from "../shared/button/Btn"
import InputSelect from "../shared/input/new/InputSelect"
import locationCityOptionsForIndex from "../../utils/locationData/locationCityOptionsForIndex"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import { BiSolidSortAlt, BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
    display: flex;
    flex-direction: column;

    .top-container{ 
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;

        .filter-container{
            display: flex;
            gap: 20px;
        }

        .btn-container{
            display: flex;
            gap: 20px;

        }

    }
    

    .table{
        width: 100%;
        border-collapse: collapse;

        thead{
            width: 100%;
            background-color: var(--color-main);

            tr{

                th{
                    color: #fff;
                    padding: 10px 15px;
                    border-right: 1px solid #fff;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    text-align: center;

                    &:first-child{
                        border-left: 1px solid var(--color-main);
                        text-align: start;
                    }

                    &:last-child{
                        border-right: 1px solid var(--color-main);
                    }

                    .title-text{
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .sort-icon{
                            font-size: 1rem;
                            cursor: pointer;
                        }
                    }

                }
            }
        }

        tbody{

            tr{
                td{

                    border: 1px solid ${({theme}) => theme.mainTextColor};
                    text-align: start;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    padding: 10px 15px;
                    text-align: center;

                    &:first-child{
                        text-align: start;
                    }

                    input{
                        width: 100%;
                        text-align: center;
                    }
                }
            }

        }
    }

    .bottom-container{
        margin-top: 30px;
        display: flex;
        justify-content: center;
    }
    
`




const initialTitles = [
    {
        id: 1,
        text: "İl/İlçe",
        sortState: 0
    },
    {
        id: 2,
        text: "Kasım",
        sortState: 0
    },
    {
        id: 3,
        text: "Aralık",
        sortState: 0
    },
    {
        id: 4,
        text: "Ocak",
        sortState: 0
    },
    {
        id: 5,
        text: "Şubat",
        sortState: 0
    },
    {
        id: 6,
        text: "Mart",
        sortState: 0
    },
    {
        id: 7,
        text: "Nisan",
        sortState: 0
    }
]

const NakliyeIklimIndex = () => {

    const dispatch = useDispatch()
    const {cityIklimIndex, isLoadingGetTopluNakliyeCityIklimIndexExcel} = useSelector(state => state.nakliyeIndex)

    const [updatedDataList, setUpdatedDataList] = useState([])

    //! bu filtreleme için
    const [townListOption, setTownListOption] = useState([])

    const [selectedCity, setSelectedCity] = useState({
        id: 6,
        text: "Ankara"
    })

    const [titles, setTitles] = useState(initialTitles)

    useEffect(() => {
        setUpdatedDataList(cityIklimIndex)
        setTownListOption(cityIklimIndex)
    },[cityIklimIndex])


    useEffect(() => {
        dispatch(getCityIklimIndex(selectedCity.id))
    },[selectedCity.id])

    // // console.log(updatedDataList);

    const handleChange = ({value, id, key}) => {

        const list = updatedDataList.map((item) => {
            if(item.id === id){
                return {...item, [key]: value === "" ? value : parseInt(value.replace(/[^0-9]/g, ''))}
            }
            else{
                return item
            }
        })

        setUpdatedDataList(list)
        setTownListOption(list)

    }

    const handleSortChange = ({id, sortState}) => {

        const titleList = titles.map((item) => {
            if(item.id === id){
                return {...item, sortState}
            }
            else{
                return { ...item, sortState: 0}
            }
        })

        if(id === 1){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => b.town.localeCompare(a.town, 'tr')))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
        }

        if(id === 2){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.kasim - b.kasim))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.kasim - a.kasim))
            }
        }

        if(id === 3){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.aralik - b.aralik))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.aralik - a.aralik))
            }
        }

        if(id === 4){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.ocak - b.ocak))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.ocak - a.ocak))
            }
        }

        if(id === 5){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.subat - b.subat))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.subat - a.subat))
            }
        }

        if(id === 6){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.mart - b.mart))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.mart - a.mart))
            }
        }

        if(id === 7){
            if(sortState === 0){
                setTownListOption([...townListOption].sort((a, b) => a.town.localeCompare(b.town, 'tr')))
            }
            else if(sortState === 1){
                setTownListOption([...townListOption].sort((a, b) => a.nisan - b.nisan))
            }
            else{
                setTownListOption([...townListOption].sort((a, b) => b.nisan - a.nisan))
            }
        }

        setTitles(titleList)
    }

    const handleSubmit = () => {

        const filtered = updatedDataList.filter((item, i) => {
            const jsonString1 = JSON.stringify(item);
            const jsonString2 = JSON.stringify(cityIklimIndex[i]);
            return jsonString1 !== jsonString2
        })    
        dispatch(updateCityIklimIndex(filtered))
    }


  return (
    <Container>
        <div className="top-container">
            <div className="filter-container">
                <InputSelect data={selectedCity.text} setData={setSelectedCity} labelText={"İl Seçiniz"} inputWidth={"220px"} initialOptions={locationCityOptionsForIndex} name={"nakliyeIklimIndexCity"}/>
            </div>
            <div className="btn-container">
                <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(showModal("nakliyeIndexCityTownIklimAddExcel"))}>Excelden Toplu Kaydet</Btn>
                <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(getTopluNakliyeCityIklimIndexExcel())} isDisabled={isLoadingGetTopluNakliyeCityIklimIndexExcel} cursor={isLoadingGetTopluNakliyeCityIklimIndexExcel && "not-allowed"}>{isLoadingGetTopluNakliyeCityIklimIndexExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktı Al"}</Btn>
            </div>
        </div>
        <table className="table">
            <thead>
                <tr>
                    {
                        titles.map((item) => (
                            <th key={item.id}>
                                <div className={"title-text"}>
                                    {item.text}
                                    {
                                        item.sortState === 0 &&
                                        <BiSolidSortAlt onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                    {
                                        item.sortState === 1 &&
                                        <BiSolidUpArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                    {
                                        item.sortState === 2 &&
                                        <BiSolidDownArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                </div>
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
            {
                    townListOption?.map((item) => (
                        <tr>
                            <td>{item.city}/{item.town}</td>
                            <td>
                                <input value={item.kasim} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "kasim"})}/>
                            </td>
                            <td>
                                <input value={item.aralik} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "aralik"})}/>
                            </td>
                            <td>
                                <input value={item.ocak} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "ocak"})}/>
                            </td>
                            <td>
                                <input value={item.subat} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "subat"})}/>
                            </td>
                            <td>
                                <input value={item.mart} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "mart"})}/>
                            </td>
                            <td>
                                <input value={item.nisan} onChange={(e) => handleChange({value: e.target.value, id: item.id, key: "nisan"})}/>
                            </td>
                        </tr>
                    ))
                }
             </tbody>
        </table>
        <div className="bottom-container">
            <Btn handleClick={handleSubmit} bgColor="#E85446" color="#fff" width={"260px"}>Güncelle</Btn>
        </div>
    </Container>
  )
}

export default NakliyeIklimIndex